export default "__VITE_PUBLIC_ASSET__7424b90d__"